import FormController from 'controllers/form-controller';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class RegistrationsAccountFormController extends FormController {
  connect() {
    super.connect();

    if (this.downloadLimitModal) {
      triggerCustomEvent(events.show_page.download_limit_modal_connects, {});
      this.initDownloadLimitModal();
    }
  }

  triggerCaptchaAndValidateFields(event) {
    event.preventDefault();

    window.handleRecaptchaResponse = () => {
      this.validateFields();
      window.handleRecaptchaResponse = null;
    };

    const { recaptchaId } = this.element.querySelector('.recaptcha-holder').dataset;
    window.grecaptcha.execute(recaptchaId);
  }

  validateFields() {
    super.validateFields();

    if (this.formValid) {
      this.continueRegistration();
    }
  }

  continueRegistration() {
    if (this.downloadLimitModal) {
      this.element.action = `${this.element.action}?download_limit=true`;
    }

    this.submit();
  }

  initDownloadLimitModal() {
    const modalElem = this.element.closest('[data-controller="ez-modal"]');

    modalElem.addEventListener('ModalClosed', this.triggerDLModalSeen);
  }

  triggerDLModalSeen() {
    // This extra custom event serves two purposes:
    // 1. to move the event handling to the window object, and
    // 2. so the download-btn-controller doesn't listen for just any modal closing event
    triggerCustomEvent('DownloadLimitModalSeen', {}, window);
  }

  get downloadLimitModal() {
    const modalWrapElem = this.element.closest('.ez-session-modal__wrap');
    return modalWrapElem.classList.contains('ez-session-modal__download-limit');
  }
}
